import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { needs } from '../../data/needs';
import { Advance } from '../ui/Advance';
import { RevealText, Stage } from '../ui/Stage';
const ease = [0.16, 1, 0.3, 1] as const;
const scatter = [{
  x: -180,
  y: -60
}, {
  x: 130,
  y: -105
}, {
  x: 195,
  y: 75
}, {
  x: -85,
  y: 120
}];

/** The pivot of the whole story. */
export function RevealStage() {
  const {
    next,
    direction,
    accent
  } = useExperience();
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const timers = [window.setTimeout(() => setPhase(1), 2600), window.setTimeout(() => setPhase(2), 3900)];
    return () => timers.forEach(window.clearTimeout);
  }, []);
  return <Stage direction={direction} className="min-h-screen items-center py-28 text-center sm:py-32" labelledBy="reveal-title" data-id="element-344" data-mp="2kqili9yhbns4">
      {/* Four solutions converging into one family */}
      <div className="pointer-events-none relative mb-14 h-40 w-full max-w-xl sm:h-52" data-id="element-345" data-mp="1i7tq9p6my796">
        {needs.map((need, index) => <motion.span key={need.id} className="absolute left-1/2 top-1/2 h-36 w-36 rounded-full blur-[38px] sm:h-44 sm:w-44" style={{
        backgroundColor: need.accent
      }} initial={{
        x: scatter[index].x - 72,
        y: scatter[index].y - 72,
        opacity: 0,
        scale: 0.7
      }} animate={{
        x: (index - 1.5) * 38 - 72,
        y: -72,
        opacity: 0.42,
        scale: 1
      }} transition={{
        duration: 2,
        delay: 0.15 + index * 0.16,
        ease
      }} data-id="element-346" data-mp="1dal31a6mrd12" data-mpi={index} />)}
        <motion.span className="absolute left-1/2 top-1/2 h-px w-64 -translate-x-1/2 bg-enamel/25" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.4,
        delay: 1.4,
        ease
      }} data-id="element-347" data-mp="kj9wbh28v29q" />
      </div>

      <h2 id="reveal-title" className="display-tight max-w-4xl text-display font-light" data-id="element-348" data-mp="1w0wk2s4h5cz">
        <span className="block text-enamel/45" data-id="element-349" data-mp="5zgx3a7bbpuy">
          <RevealText text="You may not need a better composite." delay={0.3} data-id="element-350" data-mp="5w2uc0uqlemz" />
        </span>
        <span className="mt-3 block text-enamel sm:mt-5" data-id="element-351" data-mp="3o6ddiniu7a9p">
          <RevealText text="You may need a better family." delay={1.5} data-id="element-352" data-mp="3t3wqlk3sth02" />
        </span>
      </h2>

      <AnimatePresence data-id="element-353" data-mp="komrmkv7grwi">
        {phase >= 1 && <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease
      }} className="mt-16 flex max-w-2xl flex-col items-center gap-6 border-t border-enamel/10 pt-12" data-id="element-354" data-mp="pmes439x1mcb">
            <p className="text-lede font-light text-enamel" data-id="element-355" data-mp="fuijhya7edtu">
              Different clinical situations demand different things.
            </p>
            <p className="max-w-xl text-base font-light leading-relaxed text-mute" data-id="element-356" data-mp="18d5zizacf2o2">
              Rather than asking one material to do everything, the Filtek family is three
              restoratives for three kinds of demand — plus one cousin that makes all three handle
              better.
            </p>
            {phase >= 2 && <div className="mt-6" data-id="element-357" data-mp="31utrrjg1vf9y">
                <Advance label="See the logic" onClick={next} accent={accent} align="center" delay={0.1} data-id="element-358" data-mp="2xu9xcnmv2pri" />
              </div>}
          </motion.div>}
      </AnimatePresence>
    </Stage>;
}